/**
 * AttendeesCard — the booking detail view's attendee panel (BON-145).
 *
 * Split out of the former `BookingDetailCards.tsx` (BON-335 round 4). See
 * CustomerCard.tsx for why.
 */
import type { BookingDetail } from '../../api/bookingsV2';

import { cardCls, META } from './bookingCardShared';

/**
 * Attendees — buyer-only. The v2 payload carries the buyer (customer) + a ticket
 * count, not a per-seat attendee roster (that lands in a later slice), so we
 * show the buyer as the PRIMARY attendee and headline the ticket count.
 */
export function AttendeesCard({ booking }: { booking: BookingDetail }) {
  const { customer, money } = booking;
  const customerName = [customer.firstName, customer.lastName].filter(Boolean).join(' ').trim();
  const contact = [customer.email, customer.phone].filter(Boolean).join(' · ');

  return (
    <div className={cardCls}>
      <div className="flex items-center justify-between px-5 py-4 border-b border-stone-200 dark:border-stone-700">
        <h2 className="text-sm font-semibold text-bark-900 dark:text-stone-100">Attendees</h2>
        <span className={META}>
          {money.ticketsCount} {money.ticketsCount === 1 ? 'ticket' : 'tickets'}
        </span>
      </div>
      <div className="p-5">
        <div className="flex items-start gap-2">
          <div className="min-w-0">
            <p className="text-sm font-semibold text-moss-700 dark:text-moss-300">
              {customerName || customer.email || 'Unknown'}
              <span className="ml-2 text-[10px] px-1.5 py-0.5 rounded bg-moss-100 dark:bg-moss-900/30 text-moss-700 dark:text-moss-300 font-medium align-middle">
                PRIMARY
              </span>
            </p>
            {contact && <p className="text-xs text-stone-500 dark:text-stone-400">{contact}</p>}
          </div>
        </div>
        <p className="mt-3 text-xs text-stone-400 dark:text-stone-500">
          Per-attendee details aren&rsquo;t tracked yet — only the buyer is on file.
        </p>
      </div>
    </div>
  );
}
